import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

@Directive({
    selector: '[onMove]'
})
export class OnMoveDirective implements OnDestroy {
    private changes: MutationObserver;

    @Output()
    public onMove = new EventEmitter();

    constructor(private elementRef: ElementRef) {
        const element = this.elementRef.nativeElement;

        this.changes = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => this.onMove.emit(mutation));
        }
        );

        this.changes.observe(element, {
            attributes: true,
            childList: true,
            characterData: true
        });
    }

    ngOnDestroy(): void {
        this.changes.disconnect();
    }
}